import { FC, memo } from 'react';

interface CounterBadgeProps {
  value?: number;
}

const _CounterBadge: FC<CounterBadgeProps> = ({ value }) => {
  return (
    <>
      {value ? (
        <div
          className="w-3.5 h-3.5 rounded-full text-cbadge_text text-[9px] font-bold flex justify-center items-center"
          style={{ background: 'var(--cbadge_bg)' }}>
          {value}
        </div>
      ) : (
        <div className="w-3.5 h-3.5 rounded-full flex justify-center items-center">
          <div className="loader_new" />
        </div>
      )}
    </>
  );
};

export const CounterBadge = memo(_CounterBadge);
